module.exports = "<form action=\"https://staging.wenjoy.com.co/checkout\" method=\"get\" ngNoForm>\n  <input type=\"text\" placeholder=\"Valor de la compra\" name=\"total_value\">\n  <input type=\"text\" placeholder=\"Concepto del pago\" name=\"description\">\n  <input type=\"text\" placeholder=\"API_KEY\" name=\"api_key\">\n  <button type=\"submit\">Pagar</button>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/test-checkout/test-checkout.component.html
// module id = ./src/app/test-checkout/test-checkout.component.html
// module chunks = main